/*
 * Oct 2026 QA - client feedback (mobile + hierarchy)
 *  1. Pricing: on phones show one plan at a time with a toggle (was both plans stacked, ~2,000px).
 *  2. Pricing: optional add-ons open by default on tablet/desktop (were hidden in a dropdown).
 *  3. "The smart way" feature list: on phones show the first three, with a "Show all features" button.
 */
document.addEventListener("DOMContentLoaded", () => {
	const isPhone = () => window.matchMedia("(max-width: 767px)").matches;

	// 1 + 2. Pricing blocks
	document.querySelectorAll(".pricing-blocks .pricing-container").forEach((container) => {
		const tabsWrap = container.querySelector(".mobile-pricing-options");
		const tabs = container.querySelectorAll(".pricing-tab");
		const cards = container.querySelectorAll(".pricing > .block[data-block]");

		if (tabsWrap && tabs.length > 1 && cards.length > 1) {
			tabsWrap.classList.remove("hidden");
			tabsWrap.classList.add("is-ready");
			tabsWrap.setAttribute("role", "tablist");

			const select = (n) => {
				tabs.forEach((t) => {
					const on = t.dataset.block === String(n);
					t.classList.toggle("selected", on);
					t.setAttribute("aria-selected", on ? "true" : "false");
				});
				cards.forEach((c) => c.classList.toggle("is-mobile-hidden", c.dataset.block !== String(n)));
			};

			tabs.forEach((t) => {
				t.setAttribute("role", "tab");
				t.setAttribute("tabindex", "0");
				t.addEventListener("click", () => select(t.dataset.block));
				t.addEventListener("keydown", (e) => {
					if (e.key === "Enter" || e.key === " ") {
						e.preventDefault();
						select(t.dataset.block);
					}
				});
			});

			select(tabs[0].dataset.block);
		}

		if (!isPhone()) {
			container.querySelectorAll(".faq").forEach((faq) => faq.classList.add("active"));
		}
	});

	// 3. Feature list collapse on phones
	document.querySelectorAll(".benefit-list[data-mobile-limit]").forEach((list) => {
		const limit = parseInt(list.dataset.mobileLimit, 10) || 3;
		const items = list.querySelectorAll(".benefit-item");
		if (items.length <= limit) return;

		items.forEach((item, i) => {
			if (i >= limit) item.classList.add("benefit-item--extra");
		});
		list.classList.add("is-collapsed");

		const btn = document.createElement("button");
		btn.type = "button";
		btn.className = "benefit-list__toggle btn btn--secondary md:hidden";
		btn.setAttribute("aria-expanded", "false");
		btn.textContent = "Show all features";
		btn.addEventListener("click", () => {
			const collapsed = list.classList.toggle("is-collapsed");
			btn.setAttribute("aria-expanded", collapsed ? "false" : "true");
			btn.textContent = collapsed ? "Show all features" : "Show fewer";
		});
		list.after(btn);
	});

	// 4. Arrows under the swipeable rows on phones ("Why businesses switch" tiles and the
	//    homepage product tiles) so it's obvious they scroll sideways.
	document.querySelectorAll(".scroll-mobile").forEach((row) => {
		if (row.children.length < 2) return;

		const nav = document.createElement("div");
		nav.className = "qa-scroll-nav";
		nav.innerHTML =
			'<button type="button" class="qa-scroll-nav__prev" aria-label="Previous"><i class="fal fa-arrow-left" aria-hidden="true"></i></button>' +
			'<button type="button" class="qa-scroll-nav__next" aria-label="Next"><i class="fal fa-arrow-right" aria-hidden="true"></i></button>';
		row.after(nav);

		const prev = nav.querySelector(".qa-scroll-nav__prev");
		const next = nav.querySelector(".qa-scroll-nav__next");
		const step = () => {
			const first = row.children[0];
			const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
			return first ? first.getBoundingClientRect().width + gap : row.clientWidth * 0.8;
		};
		const update = () => {
			prev.disabled = row.scrollLeft <= 2;
			next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
		};

		prev.addEventListener("click", () => row.scrollBy({ left: -step(), behavior: "smooth" }));
		next.addEventListener("click", () => row.scrollBy({ left: step(), behavior: "smooth" }));
		row.addEventListener("scroll", update, { passive: true });
		window.addEventListener("resize", update);
		update();
	});
});
